import { HttpMethods } from "../enums/HttpMethods";
import ContentFeedService from "./contentFeed.service";
import { DataWrapper } from "../interfaces/DataWrapper";
import { VariationTip } from "../interfaces/VariationTip";
import { VariationTipResponse } from "../interfaces/VariationTipResponse";
import { PostVariationTip } from "../interfaces/PostVariationTip";

const includeAllRelations = '*';
const VARIATION_TIPS = 'variation-tips';

class VariationTipsService {
  public static async getVariationTipById(id: string): Promise<VariationTip> {
    return ContentFeedService.sendRequest<DataWrapper<VariationTip>>(
      HttpMethods.GET,
      `${VARIATION_TIPS}/${id}?populate=${includeAllRelations}`
    )
      .then((wrappedRawContent: DataWrapper<VariationTip>) => {
        return wrappedRawContent.data
      })
      .catch((error: Error) => {
        throw error;
      });
  }

  public static create(variationTip: DataWrapper<PostVariationTip>): Promise<VariationTipResponse> {
    return ContentFeedService.sendRequest<DataWrapper<PostVariationTip>>(HttpMethods.POST, VARIATION_TIPS, variationTip)
      .then((wrappedVariationTip: DataWrapper<VariationTipResponse>) => wrappedVariationTip.data)
      .catch((error: Error) => {
        throw error;
      });
  }
}

export default VariationTipsService;
